import { jsx } from "react/jsx-runtime";
import { useMemo, useContext, createContext } from "react";
import { createApiClient } from "@inbody/data";
import { useAuth } from "@inbody/keycloak";
const INBODY_ONE_API_URL = "https://api-inbodyone.weareinbody.com/api";
const SEAT_BASE_PATH = "seating";
const SeatLocationApiContext = createContext(null);
const useInBodyOneClient = (baseUrl) => {
  const { keycloak, checkToken, token } = useAuth();
  return useMemo(
    () => createApiClient(baseUrl || INBODY_ONE_API_URL, {
      hooks: {
        beforeRequest: [
          async (request) => {
            await checkToken();
            const accessToken = (keycloak == null ? void 0 : keycloak.token) ?? token;
            if (accessToken) {
              request.headers.set("Authorization", `Bearer ${accessToken}`);
            }
          }
        ]
      }
    }),
    [baseUrl, keycloak, checkToken, token]
  );
};
function SeatLocationApiProvider({
  client,
  baseUrl,
  basePath,
  enabled,
  children
}) {
  const value = useMemo(
    () => ({ client, baseUrl, basePath, enabled }),
    [client, baseUrl, basePath, enabled]
  );
  return /* @__PURE__ */ jsx(SeatLocationApiContext.Provider, { value, children });
}
const useSeatLocationApi = () => {
  const config = useContext(SeatLocationApiContext);
  const inBodyOneClient = useInBodyOneClient(config == null ? void 0 : config.baseUrl);
  if ((config == null ? void 0 : config.enabled) === false) return null;
  return {
    client: (config == null ? void 0 : config.client) ?? inBodyOneClient,
    basePath: (config == null ? void 0 : config.basePath) ?? SEAT_BASE_PATH
  };
};
export {
  SeatLocationApiProvider,
  useSeatLocationApi
};
